import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class KycService {

  constructor(private http: HttpClient) {
  }

  get(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/kyc').pipe(map(data => data));
  }
}
